import { render, staticRenderFns } from "./SuspConsult.vue?vue&type=template&id=7df286aa&scoped=true"
import script from "./SuspConsult.vue?vue&type=script&lang=js"
export * from "./SuspConsult.vue?vue&type=script&lang=js"
import style0 from "./SuspConsult.vue?vue&type=style&index=0&id=7df286aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df286aa",
  null
  
)

export default component.exports